import { writable } from "svelte/store";

export type ThemePreference = "system" | "light" | "dark";

const STORAGE_KEY = "theme-preference";

function readStored(): ThemePreference {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored === "light" || stored === "dark" || stored === "system" ? stored : "system";
}

export const resolvedTheme = writable<"light" | "dark">("light");

function applyTheme(preference: ThemePreference): void {
  const root = document.documentElement;
  const systemDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
  const dark = preference === "dark" || (preference === "system" && systemDark);
  root.dataset.theme = dark ? "dark" : "light";
  resolvedTheme.set(dark ? "dark" : "light");
}

export const themePreference = writable<ThemePreference>(readStored());

themePreference.subscribe((preference) => {
  localStorage.setItem(STORAGE_KEY, preference);
  applyTheme(preference);
});

if (typeof window !== "undefined") {
  window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", () => {
    let current: ThemePreference = "system";
    themePreference.subscribe((value) => (current = value))();
    if (current === "system") applyTheme("system");
  });
}
